"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.for-each");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mobxReact = require("mobx-react");

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var GenericForm = /*#__PURE__*/function (_React$Component) {
  _inherits(GenericForm, _React$Component);

  var _super = _createSuper(GenericForm);

  function GenericForm(props) {
    var _this;

    _classCallCheck(this, GenericForm);

    _this = _super.call(this, props);
    _this.handleFormSubmitted = _this.handleFormSubmitted.bind(_assertThisInitialized(_this));
    _this.handleValidationSuccess = _this.handleValidationSuccess.bind(_assertThisInitialized(_this));
    _this.handleValidationError = _this.handleValidationError.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(GenericForm, [{
    key: "handleValidationSuccess",
    value: function handleValidationSuccess() {
      var _this$props = this.props,
          form = _this$props.form,
          onSubmit = _this$props.onSubmit;

      if (!form) {
        return;
      }

      var values = form.values();
      var filteredValues = {}; // Only pass the values of fields that were visible in the form.
      // TODO make sure this is safe and try to move this into the store

      Object.keys(values).forEach(function (key) {
        if (values.hasOwnProperty(key)) {
          if (form.$(key).isShown) {
            filteredValues[key] = values[key];
          }
        }
      });
      onSubmit(filteredValues);
    }
  }, {
    key: "handleValidationError",
    value: function handleValidationError(e) {
      var onError = this.props.onError; // TODO show form summary etc.

      onError(e);
    }
  }, {
    key: "handleFormSubmitted",
    value: function handleFormSubmitted(e) {
      e.preventDefault();
      var form = this.props.form;

      if (!form) {
        return;
      }

      this.props.onSubmitted();
      form.setFormSubmitted(true);
      form.onSubmit(e, {
        onSuccess: this.handleValidationSuccess,
        onError: this.handleValidationError
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          noTick = _this$props2.noTick,
          formStore = _this$props2.form,
          id = _this$props2.id;
      var classes = (0, _classnames.default)({
        'no-field-indicators': noTick
      });
      var extraProps = {};

      if (id) {
        extraProps.id = id;
      } else if (formStore && formStore.formConfig && formStore.formConfig.id) {
        extraProps.id = formStore.formConfig.id;
      }

      return /*#__PURE__*/_react.default.createElement("form", _extends({
        onSubmit: this.handleFormSubmitted,
        noValidate: true,
        className: classes
      }, extraProps), children);
    }
  }]);

  return GenericForm;
}(_react.default.Component);

GenericForm.defaultProps = {
  onSubmit: function onSubmit() {},
  onSubmitted: function onSubmitted() {},
  onError: function onError() {},
  noTick: false,
  children: undefined,
  id: undefined,
  form: undefined
};
GenericForm.propTypes = {
  // Form can be undefined on first render before ref is set
  form: _propTypes.default.object,
  onSubmit: _propTypes.default.func,
  onError: _propTypes.default.func,
  onSubmitted: _propTypes.default.func,
  children: _propTypes.default.node,
  noTick: _propTypes.default.bool,
  id: _propTypes.default.string
};

var _default = (0, _mobxReact.observer)(GenericForm);

exports.default = _default;
//# sourceMappingURL=GenericForm.js.map